import { createContext } from "react";

import type { ContentBlock, ContentFormat } from "../lib/types.js";

/**
 * Shape of the editable-copy context.
 *
 * Split out from `ContentContext.tsx` for the same reason as `authState.ts`:
 * React Fast Refresh can only swap a module whose exports are all components,
 * so a context object living beside its provider forces a full reload on every
 * edit to either.
 */
export interface ContentState {
  /** Overrides by key. A key with no entry renders the page's own default. */
  blocks: Record<string, ContentBlock>;
  /** True until the first fetch settles. Defaults render throughout. */
  loading: boolean;
  /**
   * Writes an override. An empty value clears it, putting the block back to
   * the copy written into the page.
   */
  save: (key: string, value: string, format: ContentFormat) => Promise<void>;
}

export const ContentContext = createContext<ContentState | null>(null);
